import React, { FC, ReactNode } from 'react';
import FormBlock from 'src/components/FormBlock';
import { OrderPalletType, OrderProductSetWithProductType, OrderType } from 'src/types/order';
import Transport from './Transport';
import { ConstantsCodesObjectType, ConstantsCodeType } from 'src/types/constantsCodes';
import {
    OrderChangelogType,
    OrderClaimsReturnsType,
    OrderExpeditionPackageType,
    OrderTransportHistoryType,
    OrderTransportLinkType
} from 'src/types/orderDetail';
import Invoice from './Invoice';
import Detail from './Detail';
import { sizes } from 'src/themes/default';
import FilesBlock from './FilesBlock';
import { UserServiceCode } from 'src/types/user';
import { EditKeysType, progressStepsCreate } from './constants';
import Progress from './Progress';
import Recipient from './Recipient';
import Billing from './Billing';
import translate from '@translate';
import Switch from 'src/components/Switch';
import { styled } from '@mui/system';
import { ProviderCompanyType } from 'src/types/providerCompany';
import ProductsTable from './ProductsTable';
import NewProductBlock from './NewProductBlock';
import ExpeditionPackagesTable from './ExpeditionPackagesTable';
import TransportHistory from './TransportHistory';
import HistoryBlock from './HistoryBlock';
import ProgressNew from './ProgressNew';
import Button from 'src/components/Button';
import { Stack } from '@mui/material';
import ClaimsReturnsTable from './ClaimsReturnsTable';
import OrderTransportsTable from './OrderTransportsTable';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { OnChangeMultipleType } from './index';
import { SOURCE_SYS_MYSKLADON } from 'skladon-types';
import PalletsTable from './PalletsTable';
import NewPalletBlock from './NewPalletBlock';
import { ProviderType } from 'src/types/provider';

export const StyledSwitchLine = styled('div')({
    margin: '20px 0px'
});

export interface RenderComponentsPropsType {
    data: OrderType | null;
    actionBusy: boolean;
    onChange: OnChangeType<EditKeysType>;
    onChangeMultiple: OnChangeMultipleType;
    editData: OrderType;
    editErrors: FormErrorsType;
    newOrder: boolean;
    disableEdit: boolean;
    permissionEditAll: boolean;
    permissionManagerEdit: boolean;
    permissionEditOrderBoxCount: boolean;
    disableEditPrintFiles: boolean;
    disableEditAllowExpedition: boolean;
    isAttributeEditDisabled: (attributeKey: string) => boolean;
    permissionOrderPalletsList: boolean;
    permissionOrderPalletsCreate: boolean;
    permissionOrderPalletsUpdate: boolean;
    canEditPalletsInCurrentStatus: boolean;
    disablePaidActions: boolean;
    allowedStatuses: ConstantsCodeType[];
    orderStatusCodes: ConstantsCodeType[];
    orderMarketplacesCodes: ConstantsCodeType[];
    boolNumberCodes: ConstantsCodeType[];
    currencyCodes: ConstantsCodeType[];
    paymentCodes: ConstantsCodeType[];
    documentTypesCodes: ConstantsCodeType[];
    shipperCodes: ConstantsCodeType[];
    serviceCodes: ConstantsCodeType[];
    orderProductCustomsTypeCodes: ConstantsCodeType[];
    orderProductCustomizationType: ConstantsCodeType[];
    orderClaimReturnTypeCodes: ConstantsCodeType[];
    orderCancelReasonCodes: ConstantsCodeType[];
    claimStatusCodesObject: ConstantsCodesObjectType;
    returnStatusCodesObject: ConstantsCodesObjectType;
    providerServiceCodes: UserServiceCode[];
    orderStatusCodesObject: ConstantsCodesObjectType;
    orderMarketplacesCodesObject: ConstantsCodesObjectType;
    orderCancelReasonCodesObject: ConstantsCodesObjectType;
    paymentCodesObject: ConstantsCodesObjectType;
    shipperCodesObject: ConstantsCodesObjectType;
    transportStatusCodesObject: ConstantsCodesObjectType;
    serviceCodesObject: ConstantsCodesObjectType;
    lineStateCodesObject: ConstantsCodesObjectType;
    orderProductCustomsTypeCodesObject: ConstantsCodesObjectType;
    orderProductCustomizationTypeCodesObject: ConstantsCodesObjectType;
    boolNumberCodesObject: ConstantsCodesObjectType;
    orderTypeCodesObject: ConstantsCodesObjectType;
    sourceSysCodesObject: ConstantsCodesObjectType;
    activeTab: string;
    changelog: OrderChangelogType | null;
    handleShowShipperLabel: (value: 'shipResponse' | 'shipReturnResponse' | 'shipSwapResponse') => void;
    sameRecipientBilling: boolean;
    allowOrderProductDetail: boolean;
    setSameRecipientBilling: (value: boolean) => void;
    onSetProviderCompany: (type: 'recipient' | 'billing') => void;
    providerCompaniesData: null | ProviderCompanyType[];
    formRef: React.RefObject<HTMLFormElement>;
    expeditionPackages: OrderExpeditionPackageType[] | null;
    transportHistory: OrderTransportHistoryType[] | null;
    orderTransports: OrderTransportLinkType[] | null;
    claimsReturns: OrderClaimsReturnsType[] | null;
    permissionOrderTransportsList: boolean;
    canCreateOrderTransport: boolean;
    handleChangeTab: (value: string, requireValidation?: boolean) => void;
    handleSave: () => void;
    incorrectMessage: string;
    productsForSets: OrderProductSetWithProductType[];
    onChangeProductsForSets: (value: OrderProductSetWithProductType[]) => void;
    setOpenProductDetailId: (value: number) => void;
    skladonUser?: number;
    allowedOrderProductEdit: boolean;
    providerData?: ProviderType | null;
    permissionEditAddress: boolean;
}

const RenderComponents: FC<RenderComponentsPropsType> = (props) => {
    const renderTransport = (summary?: boolean) => (
        <form ref={props.formRef}>
            <Progress data={props.data} changelog={props.changelog} />
            <FormBlock>
                <Detail
                    data={props.data}
                    onChange={props.onChange}
                    editData={props.editData}
                    editErrors={props.editErrors}
                    disableEdit={props.disableEdit}
                    permissionEditAll={props.permissionEditAll}
                    permissionManagerEdit={props.permissionManagerEdit}
                    orderStatusCodes={props.orderStatusCodes}
                    allowedStatuses={props.allowedStatuses}
                    newOrder={props.newOrder}
                    summary={summary}
                    incorrectMessage={props.incorrectMessage}
                    orderCancelReasonCodes={props.orderCancelReasonCodes}
                    skladonUser={props.skladonUser}
                    orderMarketplacesCodes={props.orderMarketplacesCodes}
                    isAttributeEditDisabled={props.isAttributeEditDisabled}
                    providerData={props.providerData}
                />
            </FormBlock>
            <FormBlock sx={{ marginTop: sizes.blocks_top_MG }}>
                <Invoice
                    onChange={props.onChange}
                    editData={props.editData}
                    editErrors={props.editErrors}
                    disableEdit={props.disableEdit}
                    permissionEditAll={props.permissionEditAll}
                    permissionManagerEdit={props.permissionManagerEdit}
                    disableEditAllowExpedition={props.disableEditAllowExpedition}
                    disablePaidActions={props.disablePaidActions}
                    currencyCodes={props.currencyCodes}
                    paymentCodes={props.paymentCodes}
                    summary={summary}
                    onChangeMultiple={props.onChangeMultiple}
                />
            </FormBlock>
            <FormBlock sx={{ marginTop: sizes.blocks_top_MG }}>
                <Transport
                    data={props.data}
                    onChange={props.onChange}
                    onChangeMultiple={props.onChangeMultiple}
                    editData={props.editData}
                    editErrors={props.editErrors}
                    newOrder={props.newOrder}
                    disableEdit={props.disableEdit}
                    permissionEditAll={props.permissionEditAll}
                    permissionManagerEdit={props.permissionManagerEdit}
                    permissionEditOrderBoxCount={props.permissionEditOrderBoxCount}
                    isAttributeEditDisabled={props.isAttributeEditDisabled}
                    shipperCodes={props.shipperCodes}
                    serviceCodes={props.serviceCodes}
                    providerServiceCodes={props.providerServiceCodes}
                    handleShowShipperLabel={props.handleShowShipperLabel}
                    summary={summary}
                    providerData={props.providerData}
                    skladonUser={props.skladonUser}
                />
            </FormBlock>
            <FilesBlock
                onChange={props.onChange}
                editData={props.editData}
                editErrors={props.editErrors}
                disableEdit={props.disableEdit}
                disableEditPrintFiles={props.disableEditPrintFiles}
                documentTypesCodes={props.documentTypesCodes}
                summary={summary}
                isAttributeEditDisabled={props.isAttributeEditDisabled}
                skladonUser={props.skladonUser}
            />
        </form>
    );

    const renderAddress = (summary?: boolean) => {
        const disableEditAddress = props.disableEdit && !props.permissionEditAddress;
        return (
            <form ref={props.formRef}>
                <FormBlock>
                    <Recipient
                        onChange={props.onChange}
                        editData={props.editData}
                        editErrors={props.editErrors}
                        disableEdit={disableEditAddress}
                        onSetProviderCompany={() => props.onSetProviderCompany('recipient')}
                        providerCompaniesData={props.providerCompaniesData}
                        summary={summary}
                    />
                </FormBlock>
                <StyledSwitchLine>
                    <Switch
                        value={props.sameRecipientBilling}
                        onChange={(value) => props.setSameRecipientBilling(value)}
                        label={translate('orderDetail.billingInfoSame')}
                        disabled={disableEditAddress || summary}
                    />
                </StyledSwitchLine>
                {!props.sameRecipientBilling && (
                    <FormBlock>
                        <Billing
                            onChange={props.onChange}
                            editData={props.editData}
                            editErrors={props.editErrors}
                            disableEdit={disableEditAddress}
                            onSetProviderCompany={() => props.onSetProviderCompany('billing')}
                            providerCompaniesData={props.providerCompaniesData}
                            summary={summary}
                        />
                    </FormBlock>
                )}
            </form>
        );
    };

    const renderProducts = (summary?: boolean) => (
        <>
            {!props.disableEdit && (props.allowedOrderProductEdit || props.newOrder || props.data?.SOURCE_SYS === SOURCE_SYS_MYSKLADON) && !summary && (
                <FormBlock>
                    <NewProductBlock
                        data={props.editData.ORDER_PRODUCTS || []}
                        onChange={(value: any) => props.onChange('ORDER_PRODUCTS', value, false)}
                        disableEdit={props.disableEdit}
                        orderProductCustomsTypeCodes={props.orderProductCustomsTypeCodes}
                        editErrors={props.editErrors}
                    />
                </FormBlock>
            )}
            <form ref={props.formRef}>
                <ProductsTable
                    data={props.editData.ORDER_PRODUCTS || []}
                    newOrder={props.newOrder}
                    onChange={(value, error, errorKey) => {
                        if (errorKey) {
                            props.onChange('ORDER_PRODUCTS', value, error ?? false, errorKey);
                        } else {
                            props.onChange('ORDER_PRODUCTS', value, !value.length);
                        }
                    }}
                    onChangeProductsForSets={props.onChangeProductsForSets}
                    disableEdit={props.disableEdit || (!props.allowedOrderProductEdit && props.data?.SOURCE_SYS !== SOURCE_SYS_MYSKLADON)}
                    orderProductCustomsTypeCodes={props.orderProductCustomsTypeCodes}
                    orderProductCustomizationTypeCodes={props.orderProductCustomizationType}
                    summary={summary}
                    productsForSets={props.productsForSets}
                    orderData={props.data}
                    setOpenProductDetailId={props.setOpenProductDetailId}
                    allowOrderProductDetail={props.allowOrderProductDetail}
                    editErrors={props.editErrors}
                />
            </form>
        </>
    );

    const renderPallets = (summary?: boolean) => {
        // If user doesn't have ORDER_PALLETS.LIST permission, don't render the pallets tab
        if (!props.permissionOrderPalletsList) {
            return null;
        }

        return (
            <>
                {props.canEditPalletsInCurrentStatus && props.permissionOrderPalletsCreate && !summary && (
                    <FormBlock>
                        <NewPalletBlock
                            data={props.editData.ORDER_PALLETS || []}
                            onChange={(value: any) => props.onChange('ORDER_PALLETS', value, false, undefined, true)}
                            disableEdit={!props.canEditPalletsInCurrentStatus}
                            editErrors={props.editErrors}
                        />
                    </FormBlock>
                )}
                <form ref={props.formRef}>
                    <PalletsTable
                        data={props.editData.ORDER_PALLETS || []}
                        onChange={(value: any, clearErrors?: boolean) => props.onChange('ORDER_PALLETS', value, false, undefined, clearErrors)}
                        disableEdit={!props.canEditPalletsInCurrentStatus || !props.permissionOrderPalletsUpdate}
                    />
                </form>
            </>
        );
    };

    const renderExpeditionPackages = () => (
        <form ref={props.formRef}>
            <ExpeditionPackagesTable data={props.expeditionPackages} />
        </form>
    );

    const renderTransportHistory = () => (
        <form ref={props.formRef}>
            <TransportHistory orderData={props.data} data={props.transportHistory} />
        </form>
    );

    const renderOrderTransports = () => {
        if (!props.permissionOrderTransportsList) {
            return null;
        }
        return (
            <form ref={props.formRef}>
                <OrderTransportsTable
                    data={props.orderTransports}
                    orderData={props.data}
                    transportStatusCodesObject={props.transportStatusCodesObject}
                    shipperCodesObject={props.shipperCodesObject}
                    canCreateTransport={props.canCreateOrderTransport}
                />
            </form>
        );
    };

    const renderClaimsReturns = () => (
        <>
            <form ref={props.formRef}>
                <ClaimsReturnsTable
                    data={props.claimsReturns}
                    orderClaimReturnTypeCodes={props.orderClaimReturnTypeCodes}
                    claimStatusCodesObject={props.claimStatusCodesObject}
                    returnStatusCodesObject={props.returnStatusCodesObject}
                />
            </form>
        </>
    );

    const renderHistory = () => (
        <HistoryBlock
            changelog={props.changelog}
            orderStatusCodesObject={props.orderStatusCodesObject}
            paymentCodesObject={props.paymentCodesObject}
            shipperCodesObject={props.shipperCodesObject}
            serviceCodesObject={props.serviceCodesObject}
            lineStateCodesObject={props.lineStateCodesObject}
            orderProductCustomsTypeCodesObject={props.orderProductCustomsTypeCodesObject}
            orderProductCustomizationTypeCodesObject={props.orderProductCustomizationTypeCodesObject}
            boolNumberCodesObject={props.boolNumberCodesObject}
            orderTypeCodesObject={props.orderTypeCodesObject}
            productsForSets={props.productsForSets}
            orderCancelReasonCodesObject={props.orderCancelReasonCodesObject}
            orderMarketplacesCodesObject={props.orderMarketplacesCodesObject}
            sourceSysCodesObject={props.sourceSysCodesObject}
            skladonUser={props.skladonUser}
        />
    );

    const renderStepsMovement = () => {
        const activeStepIndex = progressStepsCreate.findIndex((item) => item.key === props.activeTab);
        return (
            <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                {!!activeStepIndex && (
                    <Button
                        variant="outlined"
                        disabled={props.actionBusy}
                        onClick={() => props.handleChangeTab(progressStepsCreate[activeStepIndex - 1].key)}
                    >
                        {translate('orderDetail.action.prevStep')}
                    </Button>
                )}
                {activeStepIndex + 1 !== progressStepsCreate.length && (
                    <Button
                        disabled={props.actionBusy}
                        onClick={() => props.handleChangeTab(progressStepsCreate[activeStepIndex + 1].key, true)}
                    >
                        {translate('orderDetail.action.nextStep')}
                    </Button>
                )}
                {activeStepIndex + 1 === progressStepsCreate.length && (
                    <Button
                        disabled={props.actionBusy}
                        onClick={() => {
                            props.handleSave();
                        }}>{translate('orderDetail.action.create')}</Button>
                )}
            </Stack>
        );
    };

    if (!props.newOrder) {
        switch (props.activeTab) {
            case 'transport':
                return renderTransport();
            case 'address':
                return renderAddress();
            case 'products':
                return renderProducts();
            case 'pallets':
                // Only render the pallets tab if the user has the ORDER_PALLETS.LIST permission
                return props.permissionOrderPalletsList ? renderPallets() : null;
            case 'expeditionPackages':
                return renderExpeditionPackages();
            case 'transports':
                return renderOrderTransports();
            case 'transportHistory':
                return renderTransportHistory();
            case 'claimsReturns':
                return renderClaimsReturns();
            case 'history':
            default:
                return renderHistory();
        }
    } else {
        let renderTab: ReactNode = null;
        switch (props.activeTab) {
            case 'transport':
                renderTab = renderTransport();
                break;
            case 'address':
                renderTab = renderAddress();
                break;
            case 'products':
                renderTab = renderProducts();
                break;
            case 'summary':
            default:
                renderTab = (
                    <>
                        {renderTransport(true)}
                        {renderAddress(true)}
                        {renderProducts(true)}
                    </>
                );
                break;
        }
        return (
            <>
                <ProgressNew activeTab={props.activeTab} />
                {renderTab}
                {renderStepsMovement()}
            </>
        );
    }
};

export default RenderComponents;
